import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = {
  class: "col-xl-4 mx-auto text-center",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_3 = { class: "circle" }
const _hoisted_4 = { class: "circle-number" }

import { computed } from 'vue';
import { getAgeAtRetirement } from '@/guiide/ts/utilities';


export default /*@__PURE__*/_defineComponent({
  __name: 'RetirementAge',
  setup(__props) {

const ageAtRetirement = computed<string>(() => {
    const age = getAgeAtRetirement();
    return age == null ? null : age.toString();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "dashed-circle" }, null, -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(ageAtRetirement.value), 1)
      ])
    ])
  ]))
}
}

})